"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieBanner = void 0;
const languageUtils_1 = require("./languageUtils");
// NOTE: Record<keys, values>
const cookieText = {
    en: {
        copy: 'We use cookies to improve your experience by collecting anonymous analytics data. These cookies help us understand how visitors interact with our website and make improvements. No personal data is stored or shared. You can choose to accept or reject analytics cookies.',
        accept: 'accept',
        reject: 'reject',
    },
    ca: {
        copy: 'We use cookies to improve your experience by collecting anonymous analytics data. These cookies help us understand how visitors interact with our website and make improvements. No personal data is stored or shared. You can choose to accept or reject analytics cookies.',
        accept: 'accept',
        reject: 'reject',
    },
    uk: {
        copy: 'We use cookies to improve your experience by collecting anonymous analytics data. These cookies help us understand how visitors interact with our website and make improvements. No personal data is stored or shared. You can choose to accept or reject analytics cookies.',
        accept: 'accept',
        reject: 'reject',
    },
    au: {
        copy: 'We use cookies to improve your experience by collecting anonymous analytics data. These cookies help us understand how visitors interact with our website and make improvements. No personal data is stored or shared. You can choose to accept or reject analytics cookies.',
        accept: 'accept',
        reject: 'reject',
    },
    nz: {
        copy: 'We use cookies to improve your experience by collecting anonymous analytics data. These cookies help us understand how visitors interact with our website and make improvements. No personal data is stored or shared. You can choose to accept or reject analytics cookies.',
        accept: 'accept',
        reject: 'reject',
    },
    fr: {
        copy: "Nous utilisons des cookies pour améliorer votre expérience en collectant des données analytiques anonymes. Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web et à apporter des améliorations. Aucune donnée personnelle n'est stockée ou partagée. Vous pouvez choisir d'accepter ou de refuser les cookies analytiques.",
        accept: "J'accepte",
        reject: 'Je refuse',
    },
    de: {
        copy: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, indem wir anonyme Analysedaten sammeln. Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, und ermöglichen es uns, Verbesserungen vorzunehmen. Es werden keine personenbezogenen Daten gespeichert oder weitergegeben. Sie können Analysecookies akzeptieren oder ablehnen.',
        accept: 'Akzeptieren',
        reject: 'Ablehnen',
    },
    es: {
        copy: 'Utilizamos cookies para mejorar su experiencia mediante la recopilación de datos analíticos anónimos. Estas cookies nos ayudan a comprender cómo interactúan los visitantes con nuestro sitio web y a realizar mejoras. No se almacenan ni comparten datos personales. Puede elegir aceptar o rechazar las cookies analíticas.',
        accept: 'Acepto',
        reject: 'Rechazo',
    },
    it: {
        copy: 'Utilizziamo i cookie per migliorare la tua esperienza raccogliendo dati analitici anonimi. Questi cookie ci aiutano a capire come i visitatori interagiscono con il nostro sito web e a migliorarlo. Nessun dato personale viene memorizzato o condiviso. Puoi scegliere di accettare o rifiutare i cookie analitici.',
        accept: 'Accetto',
        reject: 'Rifiuto',
    },
    pt: {
        copy: 'Utilizamos cookies para melhorar a sua experiência através da recolha de dados analíticos anónimos. Estes cookies ajudam-nos a compreender a forma como os visitantes interagem com o nosso sítio Web e a introduzir melhorias. Nenhum dado pessoal é armazenado ou partilhado. Pode optar por aceitar ou rejeitar os cookies analíticos.',
        accept: 'Aceito',
        reject: 'Rejeito',
    },
    nl: {
        copy: 'We gebruiken cookies om uw ervaring te verbeteren door anonieme analytische gegevens te verzamelen. Deze cookies helpen ons te begrijpen hoe bezoekers omgaan met onze website en verbeteringen aan te brengen. Er worden geen persoonlijke gegevens opgeslagen of gedeeld. U kunt ervoor kiezen analytische cookies te accepteren of te weigeren.',
        accept: 'Accepteer',
        reject: 'Weiger',
    },
};
class CookieBanner {
    constructor() {
        this.banner = document.querySelector('.cookie');
        this.acceptButton = document.querySelector('.cookie__buttons--accept');
        this.rejectButton = document.querySelector('.cookie__buttons--reject');
        this.bannerText = document.querySelector('.cookie__banner__copy');
        this.language = (0, languageUtils_1.getLanguage)();
        this.init();
    }
    init() {
        if (!this.banner)
            return;
        this.updateText();
        this.setStylesBanner();
        const gtmConsent = this.getCookie('gtmConsent');
        if (gtmConsent === 'accepted') {
            this.loadGTM();
            this.hideBanner();
        }
        else if (!gtmConsent) {
            this.banner.classList.remove('cookie__hide');
        }
        this.acceptButton?.addEventListener('click', () => this.handleAccept());
        this.rejectButton?.addEventListener('click', () => this.handleReject());
    }
    updateText() {
        if (this.bannerText && this.acceptButton && this.rejectButton) {
            this.bannerText.textContent = cookieText[this.language].copy;
            this.acceptButton.textContent = cookieText[this.language].accept;
            this.rejectButton.textContent = cookieText[this.language].reject;
        }
        return;
    }
    handleAccept() {
        this.setCookie('gtmConsent', 'accepted', 365);
        this.loadGTM();
        this.hideBanner();
    }
    handleReject() {
        this.setCookie('gtmConsent', 'rejected', 1);
        this.removeGtmCookies();
        this.hideBanner();
    }
    hideBanner() {
        this.banner?.classList.add('cookie__hide');
    }
    setCookie(cookieName, value, days) {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `${cookieName}=${value}; expires=${expires}; path=/`;
    }
    getCookie(cookieName) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cookieName}=`);
        return parts.length === 2 ? parts.pop()?.split(';')[0] || null : null;
    }
    setStylesBanner() {
        const wrapper = document.querySelector('.cookie__banner__wrapper');
        if (!wrapper)
            return;
        const firstChild = wrapper.firstElementChild;
        const lastChild = wrapper.lastElementChild;
        if (firstChild)
            firstChild.style.flex = this.language === 'en' ? '2' : 'unset';
        if (lastChild)
            lastChild.style.flex = this.language === 'en' ? '1' : 'unset';
    }
    removeGtmCookies() {
        const knownCookies = ['_ga', '_gid', '_gat', '_gcl_au', '_ga_RMCW9NLCC0'];
        const allCookies = document.cookie.split(';');
        allCookies.forEach(cookie => {
            const [name] = cookie.split('=');
            const trimmedName = name.trim();
            // Match known names and dynamic GA4 cookies like _ga_XXXX
            if (knownCookies.includes(trimmedName) ||
                trimmedName.startsWith('_ga_')) {
                // Remove for both current domain and root domain
                ['.', ''].forEach(domainPrefix => {
                    document.cookie = `${trimmedName}=; path=/; domain=${domainPrefix}${window.location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
                });
                // Also remove without specifying domain
                document.cookie = `${trimmedName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
            }
        });
    }
    loadGTM() {
        const gtmID = 'G-RMCW9NLCC0';
        // Define dataLayer early
        window.dataLayer = window.dataLayer || [];
        // Define gtag before script loads
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        // Call initial gtag config before script loads
        window.gtag('js', new Date());
        window.gtag('config', gtmID);
        // Now dynamically load the gtag script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmID}`;
        script.async = true;
        script.onload = () => {
            // console.log('✅ GA4 gtag.js loaded');
        };
        document.head.appendChild(script);
        // const gtmID = 'G-RMCW9NLCC0';
        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({
        //   'gtm.start': new Date().getTime(),
        //   event: 'gtm.js',
        // });
        // const scriptTag = document.createElement('script');
        // scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${gtmID}`;
        // scriptTag.async = true;
        // scriptTag.onload = () => {
        //   console.log('GTM Script Loaded');
        //   // Define gtag and initialize
        //   const gtag = function () {
        //     window.dataLayer.push(arguments);
        //   };
        //   window.gtag = function (...args: any[]) {
        //     window.dataLayer.push(args);
        //   };
        //   window.gtag?.('js', new Date());
        //   window.gtag?.('config', gtmID);
        // };
        // document.head.appendChild(scriptTag);
        // scriptTag.onload = () => {
        //   console.log('GTM Script Loaded');
        // };
        // document.head.appendChild(scriptTag);
    }
    static checkAnalyticsOnOrOffAtStart() {
        const instance = new CookieBanner();
        if (instance.language !== 'en') {
            instance.removeGtmCookies();
            return;
        }
        const gtmConsent = instance.getCookie('gtmConsent');
        if (gtmConsent !== 'rejected') {
            instance.loadGTM();
        }
        else {
            instance.removeGtmCookies();
        }
    }
}
exports.CookieBanner = CookieBanner;
